import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ChatUser } from '@/entities/ChatUser/ChatUser'
import { AsyncReduxState, initialAsyncReduxState } from '@/redux/@config/AsyncReduxState'

export type ChatUsersState = AsyncReduxState<{
    chatUsers: ChatUser[]
}>

const initialState: ChatUsersState = {
    ...initialAsyncReduxState,
    chatUsers: [],
}

export const chatUsersSlice = createSlice({
    name: 'chatUsersReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ChatUsersState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): ChatUsersState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setChatUsers(state, action: PayloadAction<ChatUser[]>): ChatUsersState {
            return {
                ...state,
                chatUsers: action.payload,
            }
        },
    },
})

export const {
    setIsLoading,
    setError,
    setChatUsers,
} = chatUsersSlice.actions

export const chatUsersReducer = chatUsersSlice.reducer
